import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPendingApprovalGhlForms } from '../../../../../global/ducks/mlps-api';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { setAdminNewHirePendingGhlEnrollments } from '../slice/new-hire-enrollment-slices';

export function useAdminGHLPendingEnrollments() {
	const dispatch = useDispatch();

	const personGuid = useSelector<TcsmStates, string>(state => state?.authenticatedState?.clientGuid);

    useEffect(() => {
        if (personGuid) {            
            dispatch(getPendingApprovalGhlForms(               
                (response)=>{                                       
                    dispatch(setAdminNewHirePendingGhlEnrollments(response?.data));
                })); 
        }
    }, [personGuid]);

	return personGuid;
}